/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Case_Liable_Vehicle_NumberInputs */

const en_case_liable_vehicle_number = /** @type {(inputs: Case_Liable_Vehicle_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Liable vehicle ${i?.number}`)
};

const pt_br2_case_liable_vehicle_number = /** @type {(inputs: Case_Liable_Vehicle_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Veículo terceiro ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Liable vehicle {number}" |
*
* @param {Case_Liable_Vehicle_NumberInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_liable_vehicle_number = /** @type {((inputs: Case_Liable_Vehicle_NumberInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Liable_Vehicle_NumberInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_liable_vehicle_number(inputs)
	return pt_br2_case_liable_vehicle_number(inputs)
});